import React, { Fragment } from "react";
import Home from "./container/home";
import { Route, Routes } from "react-router-dom";
import DeleteAccount from "./container/delete-account";
import PrivacyPolicy from "./container/privacy-policy/index";
import TermsOfUse from "./container/terms-of-use/index";
import { ToastContainer } from "react-toastify";

function App() {
  return (
    <Fragment>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-use" element={<TermsOfUse />} />
        <Route path="/delete-me" element={<DeleteAccount />} />
      </Routes>
      <ToastContainer />
    </Fragment>
  );
}

export default App;
